import { ReactNode, useRef, useState } from 'react';
import classnames from 'classnames';
import { createUseStyles } from 'react-jss';

import { Theme } from '@app/theme';
import { AnimatedSlidingDiv } from '@app/core';

const useStyles = createUseStyles((theme: Theme) => ({
  block: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.std,
    border: {
      color: theme.colors.grayBorder,
      style: 'solid',
      width: 1,
    },
    padding: theme.marginBase * 3,
    marginBottom: theme.marginBase * 3,
  },
  head: {
    ...theme.fonts.h4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.marginBase,
    width: '100%',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textAlign: 'left',
  },
  icon: {
    fontSize: theme.iconSize.large,
    color: theme.colors.inkSecondary,
    transition: 'transform .3s',
  },
  iconOpen: {
    transform: 'rotate(180deg)',
  },
  content: {
    paddingTop: theme.marginBase * 2,
  },
}));

interface Props {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

export const QuoteFoldableBlock = ({
  title,
  children,
  defaultOpen = false,
}: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(defaultOpen);
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className={classes.block}>
      <button
        type="button"
        aria-expanded={open}
        className={classes.head}
        onClick={() => setOpen((current) => !current)}
      >
        {title}
        <i
          className={classnames('ri-arrow-down-s-line', classes.icon, {
            [classes.iconOpen]: open,
          })}
        />
      </button>

      <AnimatedSlidingDiv
        isOpen={open}
        maxHeight={(contentRef.current?.clientHeight || 600) + 40}
      >
        <div ref={contentRef} className={classes.content}>
          {children}
        </div>
      </AnimatedSlidingDiv>
    </div>
  );
};
